import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const fileUrl = (id) => `${API}/files/${id}`;

export const brl = (v) =>
  v == null ? "Sob consulta" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Erro inesperado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x?.loc || []).slice(1).join(".")}: ${x?.msg || ""}`).join(" · ");
  return d.msg || String(d);
}

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR") : "—");
export const fmtDay = (s) => {
  if (!s) return "—";
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s.split("-").reverse().join("/");
  return new Date(s).toLocaleString("pt-BR");
};
export const todayISO = () => new Date().toISOString().slice(0, 10);
